// extracted by mini-css-extract-plugin
export default {"TablePreviewWrapper":"izCJ3gzZWqLDf8S5Kv5yLw==","ColumnHeader":"s2HA5-njcECE43tf-HgwCQ=="};